import { UseQueryOptions, useQuery } from 'hooks/react-query';
import { ApiError, ApiResult } from '@models/api';
import { SavedApplicationDataResponse } from '../models';

function useRGetSavedApplication<
  TData = SavedApplicationDataResponse<'personal_identity'>,
>(
  options: UseQueryOptions<ApiResult<TData>, ApiError> & { step: number } = {
    step: 1,
  },
) {
  const { step, enabled, ...resOptions } = options;

  return useQuery({
    queryKey: ['application/form/load', { step }],
    enabled,
    ...resOptions,
  });
}

export default useRGetSavedApplication;
